import { Link } from 'react-router-dom'

export function PrivacyPage() {
  return (
    <main className="mx-auto max-w-3xl space-y-6 p-8">
      <header>
        <h1 className="text-2xl font-semibold">Datenschutzerklärung</h1>
      </header>

      <p className="rounded-md border bg-muted/40 p-3 text-sm text-muted-foreground">
        MindKeep läuft aktuell als funktionierender Prototyp (Case). Lade bitte keine vertraulichen
        Produktivdaten hoch.
      </p>

      <section className="space-y-3 text-sm leading-6 text-muted-foreground">
        <h2 className="text-base font-medium text-foreground">Verantwortlich</h2>
        <p>
          Huebner Management GmbH, Im Reberle 8, FL-9494 Schaan, Liechtenstein. Kontakt:{' '}
          <a
            className="font-medium text-foreground underline-offset-4 hover:underline"
            href="mailto:hartmut@huebner.io"
          >
            hartmut@huebner.io
          </a>
        </p>
      </section>

      <section className="space-y-3 text-sm leading-6 text-muted-foreground">
        <h2 className="text-base font-medium text-foreground">Das Wichtigste in Kürze</h2>
        <ul className="list-disc space-y-2 pl-5">
          <li>Konto-Daten (Name, E-Mail) dienen dem Login und der Zugehörigkeit zu deinem Workspace.</li>
          <li>Deine Inhalte bleiben in deinem eigenen Workspace — isoliert von anderen Kunden.</li>
          <li>KI-Verarbeitung erfolgt ausschliesslich in der EU (Mistral AI).</li>
          <li>
            MindKeep verwendet keine Tracking-Cookies; es werden nur technisch notwendige Speicherungen
            genutzt (z.B. deine Sitzung).
          </li>
          <li>Datenexport und Account-Löschung findest du in den Einstellungen unter „Profil“.</li>
        </ul>
      </section>

      <section className="rounded-lg border bg-card p-4 text-sm leading-6">
        <p className="text-muted-foreground">
          Die vollständige Datenschutzerklärung (inkl. aller Auftragsverarbeiter) findest du auf huebner.io.
        </p>
        <a
          data-testid="privacy-external-link"
          className="mt-2 inline-block font-medium text-primary underline-offset-4 hover:underline"
          href="https://huebner.io/de/datenschutz"
          target="_blank"
          rel="noreferrer"
        >
          Vollständige Datenschutzerklärung auf huebner.io
        </a>
      </section>

      <footer className="text-xs text-muted-foreground">
        <Link className="underline-offset-4 hover:underline" to="/legal/impressum">
          Impressum
        </Link>
        {' · '}
        <Link className="underline-offset-4 hover:underline" to="/legal/terms">
          Nutzungsbedingungen
        </Link>
      </footer>
    </main>
  )
}
